import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ContentDialogData } from '../../type/dialog.type';
import { GenericDialogDirective } from '../generic-dialog.directive';
import { NgIf } from '@angular/common';
import { merge } from 'lodash-es';

@Component({
  selector: 'portal-ui-content-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatButtonModule, NgIf],
  templateUrl: './content-dialog.component.html',
  styles: [
    `
      :host {
        @apply block min-w-64;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentDialogComponent extends GenericDialogDirective {
  protected readonly dialog: MatDialogRef<ContentDialogComponent, boolean> = inject(MatDialogRef<ContentDialogComponent, boolean>);
  protected readonly config: ContentDialogData = merge<ContentDialogData, ContentDialogData>(
    { title: '', button: { close: { label: 'Close' } } },
    inject(MAT_DIALOG_DATA),
  );
}
